export class ClientEntryData{
    public document: string;
    public email: string;
    public phone: string;
    public offers = [];

    constructor(){
    }
}